import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DialogMoveToCategoryComponent } from 'app/modules/projects/dialog-move-to-category/dialog-move-to-category.component';
import { ProjectsService } from 'app/services/projects.service';
import { FilesService } from '../../../services/files.service';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { TranslocoService } from '@ngneat/transloco';
import { GAnalyticsService } from '../../../services/g-analytics.service';

@Component({
  selector: 'app-files-list',
  templateUrl: './files-list.component.html',
  styleUrls: ['./files-list.component.scss'],
})
export class FilesListComponent implements OnInit {
  @Input() files: { project: File[]; report: File[]; category: File[] } = {
    project: [],
    report: [],
    category: [],
  };
  @Input() type: 'project' | 'report' | 'category';
  @Output() reloadCategories: EventEmitter<any> = new EventEmitter<any>();
  @Input() categories: any[] = [];

  subscription: Subscription = new Subscription();

  constructor(
    private filesService: FilesService,
    private projectService: ProjectsService,
    private dialog: MatDialog,
    private toaster: ToastrService,
    private route: ActivatedRoute,
    private translocoService: TranslocoService,
  ) {}

  fragment: string;
  error: string[] = [];
  project_id: string;

  ngOnInit(): void {
    this.reloadCategories.emit();
    this.project_id = this.route.snapshot.params['project_id'];
  }

  downloadFile(filePath: string, fileName: string): void {
    this.filesService.download(filePath, fileName);
  }

  moveToCategory(fileId: string): void {
    const dialogRef = this.dialog.open(DialogMoveToCategoryComponent, {
      width: '350px',
      disableClose: true,
      data: { categories: this.categories },
    });
    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result) {
          const moveToBody = {
            file_id: fileId,
            category_id: result.id,
          };
          this.projectService.moveToCategory(moveToBody).subscribe(
            () => {
              if (this.fragment) {
                this.categories = this.categories.filter((value1) => value1.id !== result.id);
              } else {
                this.categories.filter((value1) => value1.id === result.id)[0].category = {
                  category_name: result.category_name,
                  id: result.id,
                };
              }
              this.toaster.success(
                this.translocoService.translate('Category has been successfully moved'),
              );
              this.reloadCategories.emit();
            },
            (error) => {
              this.toaster.warning(error.error.error[0].toUpperCase());
            },
          );
        }
      },
      (error) => {
        this.toaster.error(error.error.error);
      },
    );
  }
}
